<template>
  <div>
    <div class="size-full">
      <div class="hidden size-full flex-col md:flex">
        <div class="h-full py-56">
          <RevSkeleton height="100%" shape="line" />
        </div>
        <div class="flex w-full grow flex-row space-x-8">
          <div class="flex w-full grow flex-col space-y-8">
            <RevSkeleton height="1.2rem" shape="line" width="100%" />
            <RevSkeleton height="1.2rem" shape="line" width="100%" />
          </div>
          <div class="flex w-full grow flex-col space-y-8">
            <RevSkeleton height="1.2rem" shape="line" width="100%" />
            <RevSkeleton height="1.2rem" shape="line" width="100%" />
          </div>
        </div>
        <div class="h-[3.125rem]"></div>
      </div>
      <div class="mb-24 flex size-full space-x-8 md:mb-0 md:hidden">
        <div class="w-full">
          <RevSkeleton height="100%" shape="line" width="5.5rem" />
        </div>
        <div class="w-full space-y-8">
          <RevSkeleton height="1rem" shape="line" width="10.0rem" />
          <RevSkeleton height="1rem" shape="line" width="15.0rem" />
          <RevSkeleton height="2rem" shape="line" width="5.0rem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
